import { useEffect, useState } from 'react'
import DataTable from 'react-data-table-component';
import { FaEdit } from 'react-icons/fa';
import { useSelector, useDispatch } from 'react-redux';
import { useLocation } from 'react-router-dom';
import { toast } from 'react-toastify';
import { selectAuth, setActiveTab } from '../../redux/features/authSlice';
import { IAuthUser } from '../../redux/features/authSlice/authSlice.types';
import jwt_decode from 'jwt-decode';
import CustomLoading from '../../components/CustomLoading';
import CustomModal from '../../components/CustomModal';
import * as Yup from 'yup';
import { useFormik } from "formik";
import { useGetPickupRequestListQuery, useUpdatePickupRequestMutation } from '../../redux/api/pickupApi/pickupApi';
import CustomInput from '../../components/CustomInput';

const statusColor = {
    Stored: "bg-[#0cba06]/10 text-[#0cba06]",
    Requested: "bg-[#baa506]/10 text-[#baa506]",
    Accepted: "bg-[#06bab4]/10 text-[#06bab4]",
};

const PickupRequestList = () => {
    const dispatch = useDispatch();
    const { pathname } = useLocation();
    const { token } = useSelector(selectAuth);
    const authData: IAuthUser = token ? jwt_decode(token) : null;
    const { data: pickupRequestList, isLoading: pickupParceLoading } = useGetPickupRequestListQuery(
        authData?.id
    );

    const [pickupParcelInfo, setPickupParcelInfo] = useState(null);
    const [showModal, setShowModal] = useState(false);
    const [updatePickupRequest, pickupRequestResult] = useUpdatePickupRequestMutation();

    const validationSchema = Yup.object().shape({
        numberofparcel: Yup.string().required("Number of parcel is required"),
    });

    const initialValues = {
        numberofparcel: ""
    };

    const formik = useFormik({
        initialValues,
        validationSchema,
        onSubmit: async (values, { resetForm }) => {
            const data = {
                "rider_id": authData?.id,
                "parcel_count": values.numberofparcel,
                "status": "Accepted"
            };
            try {
                await updatePickupRequest({ data, id: pickupParcelInfo?.id })
                toast.success("Request has been accepted!");
                resetForm();
                setShowModal(false);
            } catch (error) {
                console.log(error);
                toast.error(error?.data?.message || "Something went wrong!");
            }
        },
    });

    const {
        handleSubmit,
        values,
        touched,
        errors,
        setFieldValue,
        handleBlur,
    } = formik;

    const columns = [
        {
            name: "Address",
            selector: (row) => row?.pickup_location,
            sortable: true,
        },
        {
            name: "Weight",
            selector: (row) => row?.weight,
            sortable: true,
        },
        {
            name: "No of Parcel",
            selector: (row) => row?.parcel_count,
            sortable: true,
        },
        {
            name: "Status",
            selector: (row) => (
                <div
                    className={`py-1 w-20 text-center rounded ${statusColor[row?.status]
                        }`}
                >
                    {row?.status}
                </div>
            ),
            sortable: true,
        },
        {
            name: "Action",
            cell: (row) => (
                <div
                    onClick={() => {
                        setPickupParcelInfo(row);
                        if (row?.status === 'Accepted') {
                            toast.info("Pickup request already accepted!")
                        } else {
                            if (row?.status === 'Stored') {
                                toast.info("Pickup request already stored!")
                            } else {
                                setShowModal(true);
                            }
                        }

                    }}
                    className={`flex flex-row gap-2 items-center justify-center py-1 w-20 text-center rounded border bg-secondary/10 border-secondary text-secondary cursor-pointer transition-all hover:bg-secondary hover:animate-pulse hover:text-white`}
                >
                    <FaEdit /> Edit
                </div>
            ),
        },
    ];

    useEffect(() => {
        if (pickupRequestList) {
            setFieldValue('numberofparcel', pickupRequestList?.parcel_count);
        }
    }, [pickupRequestList]);

    useEffect(() => {
        if (pathname === "/pickup-request-list") {
            dispatch(setActiveTab("Pickup Request List"));
        }
    }, [dispatch, pathname]);
    return (
        <div className="w-full flex flex-col gap-10">
            <div className="bg-white shadow-lg rounded-lg p-4 justify-between flex flex-row gap-10">
                <div className="flex flex-col justify-between w-full gap-4">
                    <div className="flex flex-col sm:flex-row justify-between items-center gap-4">
                        <div className="text-2xl font-bold text-text_1">Pickup Request List</div>
                    </div>
                    <div className="flex flex-row gap-4 items-center w-full">
                        <div className='text-text_2 italic text-lg'>A list of requests for arranging pickups</div>
                    </div>
                </div>
                <div className="h-40 hidden lg:flex">
                    <img
                        src="https://res.cloudinary.com/di23omfvx/image/upload/v1692428968/self_driving_car_Road_1_npjom3.gif"
                        alt="self drive"
                        className="h-full w-full"
                    />
                </div>
            </div>
            <div className="overflow-x-auto bg-white shadow-lg rounded-lg p-2">
                <DataTable
                    columns={columns}
                    data={pickupRequestList}
                    pagination
                    persistTableHead
                    highlightOnHover
                />
            </div>

            <CustomModal
                showModal={showModal}
                setShowModal={setShowModal}
                handleSubmit={handleSubmit}
                submitButton={true}
                title={"Update Pickup Status"}
                className="sm:min-w-[70%] md:min-w-[60%] lg:min-w-[25vw] xl:min-w-[20vw]"
            >
                <CustomInput
                    label="NUMBER OF PARCEL"
                    type="text"
                    setFieldValue={setFieldValue}
                    value={values.numberofparcel}
                    touched={touched.numberofparcel}
                    error={errors.numberofparcel}
                    handleBlur={handleBlur}
                />
            </CustomModal>

            {(pickupParceLoading || pickupRequestResult?.isLoading) && <CustomLoading />}
        </div>
    )
}

export default PickupRequestList